/**
 * PensionsTabs — shared tab bar for pension pages (DC Optimiser + DB).
 */
import { useLocation } from 'react-router-dom'

const TABS: Array<{ href: string; label: string }> = [
  { href: '/app/pension', label: 'DC SIPP Optimiser' },
  { href: '/app/db-pensions', label: 'DB Pensions' },
]

export default function PensionsTabs() {
  const location = useLocation()
  const current = location.pathname

  return (
    <div className="flex items-center gap-1 border-b border-border flex-wrap">
      {TABS.map(t => {
        const active = current === t.href
        return (
          <a
            key={t.href}
            href={t.href}
            className={
              active
                ? 'px-4 py-2.5 text-sm font-medium border-b-2 border-blue-light text-blue-light -mb-px'
                : 'px-4 py-2.5 text-sm font-medium text-text-muted hover:text-text-secondary border-b-2 border-transparent -mb-px'
            }
          >
            {t.label}
          </a>
        )
      })}
    </div>
  )
}
